import { Box, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React from "react";
import { useTranslate } from "react-admin";

export const ImportErrorsAlert = ({ errors, onClose }) => {
	const t = useTranslate();

	if (!errors || errors.length === 0) {
		return null;
	}

	return (
		<Box mb={2}>
			<Alert
				severity="error"
				onClose={onClose ? () => onClose(null) : undefined}
				style={{ maxHeight: "300px", overflow: "auto" }}
			>
				<Typography variant="subtitle2" gutterBottom>
					{t("osfc.dialogs.import.errors_found", { count: errors.length })}
				</Typography>
				<Box component="ul" m={0} pl={2} style={{ fontSize: "0.85rem" }}>
					{errors.map((error, index) => (
						<li key={index}>{error}</li>
					))}
				</Box>
			</Alert>
		</Box>
	);
};
